<template functional>
  <v-progress-linear
    :indeterminate="props.value"
    class="ma-0 pa-0"
    background-opacity="0"
    color="accent"
    height="2"></v-progress-linear>
</template>

<script>
export default {
  props: {
    value: Boolean,
  },
};
</script>
